import { FileValidation } from './types';

export const MAX_FILE_BYTES = 25 * 1024 * 1024;

const ALLOWED = new Set<string>([
  'application/pdf',
  'image/jpeg', 'image/png', 'image/gif', 'image/webp',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain', 'text/csv',
]);

export const isAllowedMime = (mime: string): boolean => ALLOWED.has(mime);

export const validateFile = (file: { type: string; size: number }): FileValidation => {
  if (!isAllowedMime(file.type)) return { ok: false, error: 'file type not allowed' };
  if (file.size > MAX_FILE_BYTES) return { ok: false, error: 'file exceeds 25 MB' };
  return { ok: true };
};

const slug = (s: string): string => s.trim().replace(/\s+/g, '-');

export const buildStoragePath = (accountPrefix: string, clientId: string, ts: number, filename: string): string =>
  `${accountPrefix}documents/${clientId}/${ts}-${slug(filename)}`;

export const formatSize = (bytes: number): string => {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.round(bytes / 1024)} KB`;
};

export const isImage = (mime: string): boolean => mime.startsWith('image/');

export const buildFolderPath = (
  folderId: string | null,
  foldersById: { [id: string]: { name: string; parentId: string | null } }
): string => {
  const parts: string[] = [];
  const seen = new Set<string>();
  let cur = folderId;
  while (cur && foldersById[cur] && !seen.has(cur)) {
    seen.add(cur);
    parts.unshift(foldersById[cur].name);
    cur = foldersById[cur].parentId || null;
  }
  return parts.join(' / ');
};
